export const kinship = [
    { value: 1, label: "Pai" },
    { value: 2, label: "Mãe" },
    { value: 3, label: "Filho(a)" },
    { value: 11, label: "Cônjuge" },
    { value: 12, label: "Outros" },
]